export default {
  AUTH_FAIL: 'AUTH_FAIL',
  MANUAL_SIGN_OUT: 'MANUAL_SIGN_OUT',
} as const;
